<template>
  <div class="header">
    <div class="menu-wrapper">
      <ul class="menu-mobile">
        <li>
          <router-link :to="{ name: 'index' }" exact>
            <img src="../assets/pos_logo.png" alt="logo" />
          </router-link>
        </li>
      </ul>
      <ul class="menu-mobile">
        <li>
          <div class="menu-icon" @click="openMenu">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
        </li>
      </ul>
      <ul class="menu">
        <li>
          <a href="https://retail.connectpos.com/" exact>
            <UiBaseIcon iconName="monitor" height="30" width="30" /> Connectpos
          </a>
        </li>
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <UiBaseIcon iconName="report" height="30" width="30" /> {{ $t('report') }}
          </router-link>
        </li>
      </ul>
      <div v-if="isKidz()">
        <p style="font-size: 24px; color: crimson;">
          Access to report system will be blocked from Feb 29 2024 23:59
        </p>
      </div>
      <ul class="menu side" :key="dropdownDesktopKey">
        <li>
          <div class="locale-changer">
            <select v-model="$i18n.locale">
              <option v-for="locale in ['en', 'fr']" :key="`locale-${locale}`" :value="locale">{{ locale.toLocaleUpperCase() }}
              </option>
            </select>
          </div>
        </li>
        <li>
          <UiUserDropdown :listStore="listStore" :currentUser="currentUser" :currenStore="currenStore"
            @changeStore="changeStore" @logout="onLogout" :key="keyDropdown" />
        </li>
      </ul>
    </div>
    <div class="menu-mobile-wapper" :key="dropdownMobileKey">
      <UiMenuMobile closeOnOverlay :show.sync="isShownMenuMobile" @logout="onLogout" @changeStore="changeStore"
        :currentUser="currentUser" :currenStore="currenStore" :listStore="listStore" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import reportType from '@/config/reportType'
import { AuthService } from '../services/auth.service'
import UiBaseIcon from '@/components/icons/UiBaseIcon'
import UiUserDropdown from '@/components/UiUserDropdown'
import UiMenuMobile from '@/components/UiMenuMobile'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import StoreService from '@/services/store.service'
import { platform } from '../constants/storePlatform'

export default {
  name: 'Header',
  components: {
    UiBaseIcon,
    UiUserDropdown,
    UiMenuMobile
  },
  data() {
    return {
      isShownMenuMobile: false,
      currentUser: {},
      currenStore: null,
      dropdownMobileKey: 0,
      dropdownDesktopKey: 0,
      keyDropdown: 0
    }
  },
  computed: {
    ...mapGetters({
      listStore: 'store/getListStore',
      getListCurrencyRates: 'currency/getCurrencyRates',
      getQuery: 'report/getQuery'
    })
  },
  created() {
    const currentUser = getItemByLocalStorage(localStorageKey.CURRENT_USER)
    const currenStore = getItemByLocalStorage(localStorageKey.STORE_ID)
    this.currenStore = currenStore
    this.currentUser = currentUser
    this.getListStoreByUser(currentUser.id).then(() => {
      this.dropdownDesktopKey = Math.random()
      this.dropdownMobileKey = Math.random()
    })
    this.getListOutletByStore(currenStore)
    this.getUsers({ page: 1 })
    this.getCurrencies()
    this.getCurrencyRates()
  },
  methods: {
    ...mapActions({
      getListStoreByUser: 'store/getListStoreByUser',
      getListOutletByStore: 'outlet/getListOutletByUser',
      changeStoreGetReportData: 'report/changeStoreGetReportData',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates',
      getCatalog: 'catalog/getListCatalogByOulet',
      clearCatalogData: 'catalog/clearCatalogData',
      getProductChart: 'report/getProductSoldSumStore',
      getUsers: 'report/getUsers',
      getTippingReportData: 'report/getTippingReportDataByStore',
      getTippingReportSummary: 'report/getTippingReportSummary',
      getOrdersReportSummary: 'report/getOrdersReportSummary',
      getCategoriesFilter: 'catalog/getCategoriesFilter',
      setChangeStore: 'report/setChangeStore',
      getCustomStatuses: 'order/getListCustomStatus'
    }),
    openMenu() {
      this.isShownMenuMobile = true
    },
    async changeStore(storeID, type, storeExternalId) {
      if (window.location.pathname === '/global-stores' || window.location.pathname === '/global') {
        this.$router.push({ path: 'dashboard' })
      }
      this.keyDropdown = Math.random()
      this.currenStore = storeID
      this.setChangeStore(true)
      setLocalStorage(localStorageKey.STORE_ID, storeID)
      setLocalStorage(localStorageKey.STORE_EXTERNAL_ID, storeExternalId)
      setLocalStorage(localStorageKey.CURRENT_PLATFORM, type)
      let viewId = null
      this.$store.commit('common/SET_LOADING', true)
      if (platform.isMagentoPlatform(type)) {
        const taxConfig = await StoreService.getTaxConfigs(storeID)
        if (taxConfig && taxConfig.data && taxConfig.data.items) {
          viewId = platform.getStoreView(taxConfig.data.items)
        }
        if (!viewId || viewId.length < 1) {
          const views = await StoreService.getViews(storeID)
          if (views && views.data && views.data.items) {
            viewId = platform.getStoreView(views.data.items)
          }
        }
      }
      let storeConfig
      try {
        storeConfig = await StoreService.getStoreConfig(storeID, viewId)
      } catch (error) {
        storeConfig = { data: {} }
      }
      setLocalStorage(localStorageKey.STORE_CONFIG, storeConfig.data)
      this.getCurrencyRates().then(() => {
        const currentCurrency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
        const currentStoreConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)

        if (currentCurrency && currentStoreConfig && currentCurrency.toCurrency !== currentStoreConfig.currency) {
          const currentCurrencyRate = this.getListCurrencyRates.find(currencyRate => currencyRate.fromCurrency === currentStoreConfig.currency && currencyRate.toCurrency === currentCurrency.toCurrency && currencyRate.storeId === storeID)
          if (currentCurrencyRate) {
            const rate = currentCurrencyRate.rate
            setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currentCurrency, rate })
          }
        }
      })

      this.changeStoreGetReportData().then(() => {
        if (window.location.pathname === '/product-sold' || window.location.pathname === '/revenue-by-product') {
          this.getCatalog()
        } else {
          this.clearCatalogData()
        }
        if (window.location.pathname === '/product-sold') {
          this.getProductChart({
            query: {
              limit: 1000,
              productCategoryId: null
            }
          })
        } else if (window.location.pathname === '/tippings') {
          this.getTippingReportData({
            query: {
              page: 1,
              limit: 20
            }
          })
          this.getTippingReportSummary({
            query: {
              page: 1
            }
          })
          this.getUsers({ page: 1 })
        } else if (window.location.pathname === '/order-status' || window.location.pathname === '/payment-status') {
          var day
          if (this.getQuery && this.getQuery.outletIds) {
            day = {
              createdAtMin: new Date(this.getQuery.createdAtMin).toJSON(),
              createdAtMax: new Date(this.getQuery.createdAtMax).toJSON()
            }
          }
          this.getOrdersReportSummary({
            type: reportType.saleSummary,
            query: {
              ...day,
              mode: 'DATE'
            }
          })
        } else if (window.location.pathname === '/revenue-by-category') {
          this.getCategoriesFilter({
            query: { ...this.getQuery, page: 1, limit: 30 }
          })
        }
      })
      this.getListOutletByStore(storeID)
      this.getCustomStatuses()
    },
    async onLogout() {
      await AuthService.makeLogout()
    },
    isKidz() {
      const currentUser = getItemByLocalStorage(localStorageKey.CURRENT_USER)
      const today = new Date()
      const month = today.getMonth() + 1
      const date = today.getDate()
      const isInvalidTimeKidz = (month > 2) || (month === 2 && date >= 27)
      return currentUser.username === 'kidzaniahn' && isInvalidTimeKidz && false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  z-index: 12;
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  padding-left: 50px;
  background-color: #e7e7e7;

  .is-active {
    color: #11b4a8;
  }

  a {
    color: #000;
    text-decoration: none;
    display: flex;
    align-items: center;
    font-size: 14px;

    span {
      margin-right: 15px;
    }
  }

  .menu-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .menu-mobile {
      display: none;

      .menu-icon {
        cursor: pointer;

        .line {
          margin: 2px 0;
          width: 25px;
          height: 4px;
          background-color: #cccccc;
        }
      }
    }
  }

  .menu-mobile-wapper {
    display: none;
  }

  .menu {
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      padding: 15px;
    }

    &.side {
      font-size: 15px;

      .logout-button {
        cursor: pointer;
      }
    }
  }

  .locale-changer {
    margin-left: 15px;

    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 100px;
      outline: none;
      border-radius: 4px;
      border: 0;
      background-color: #fff;
    }
  }
}

@include media_tablet {
  .header {
    padding-left: 0px;
    background-color: $color-black-100;

    .menu {
      display: none;
    }

    .menu-wrapper {
      .menu-mobile {
        display: block;

        li {
          padding: 15px;
        }
      }
    }
  }

  .menu-mobile-wapper {
    display: block !important;
  }
}
</style>
